import { LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { appButtonStyles } from './app-button.css';
import { renderAppButtonPresentation, type AppButtonProps } from './app-button-presentation';

@customElement('app-button')
export class AppButton extends LitElement {
  static styles = [appButtonStyles];

  @property({ type: String }) variant: AppButtonProps['variant'] = 'primary';
  @property({ type: String }) size: AppButtonProps['size'] = 'md';
  @property({ type: String }) type: AppButtonProps['type'] = 'button';
  @property({ type: Boolean }) disabled = false;
  @property({ type: String }) label = '';

  private handleClick(e: MouseEvent) {
    if (this.disabled) return;
    this.dispatchEvent(
      new CustomEvent('app-click', {
        detail: { originalEvent: e },
        bubbles: true,
        composed: true,
      })
    );
  }

  render() {
    const props: AppButtonProps = {
      variant: this.variant,
      size: this.size,
      type: this.type,
      disabled: this.disabled,
      label: this.label,
      onClick: (e) => this.handleClick(e),
    };

    return renderAppButtonPresentation(props);
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'app-button': AppButton;
  }
}
